import { BUTTON_TEXT_SX, COLORS, FONTS } from './tokens';

export const PAGE_SECTION_SX = {
  py: { xs: 3, md: 5 },
};

export const PAGE_TITLE_SX = {
  fontFamily: FONTS.heading,
  fontWeight: 600,
  fontSize: { xs: '1.625rem', md: '2rem' },
  lineHeight: 1.2,
  color: COLORS.textPrimary,
};

export const PANEL_SX = {
  border: `1px solid ${COLORS.borderHairline}`,
  borderRadius: '2px',
  boxShadow: 'none',
  bgcolor: '#FFFFFF',
};

export const WARM_PANEL_SX = {
  ...PANEL_SX,
  bgcolor: COLORS.surfacePanel,
};

export const FORM_FIELD_SX = {
  '& .MuiOutlinedInput-root': {
    minHeight: 50,
    borderRadius: '2px',
    bgcolor: '#FFFFFF',
  },
  '& .MuiInputLabel-root': {
    fontSize: '0.75rem',
    fontWeight: 600,
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    color: COLORS.textWarmMuted,
  },
};

export const PRIMARY_BUTTON_SX = {
  ...BUTTON_TEXT_SX,
  minHeight: 50,
  borderRadius: '2px',
  boxShadow: 'none',
  '&:hover': {
    bgcolor: COLORS.greenDark,
    boxShadow: 'none',
  },
};

export const SECONDARY_BUTTON_SX = {
  ...BUTTON_TEXT_SX,
  minHeight: 48,
  borderRadius: '2px',
  borderColor: COLORS.green,
  color: COLORS.green,
  '&:hover': {
    borderColor: COLORS.green,
    bgcolor: 'rgba(58,79,65,0.05)',
  },
};

export const QUIET_LINK_SX = {
  color: COLORS.green,
  fontSize: '0.8125rem',
  fontWeight: 700,
  textDecoration: 'underline',
  textUnderlineOffset: '3px',
};
